const lang = {
  breadcrumb: {
    profile: 'マイプロフィール',
  },
  title: 'プロフィールを設定する',
  title_confirm: '（確認）',
  label: {
    id: 'ID',
    email: 'メールアドレス',
    belonging: '所属',
    belonging_note: '※ 所属に合わせて入力してください。',
    required: '※必須',
    our_company: '自社',
    division: '事業部',
    if_not_in_our_company: '【自社以外の所属の場合】',
    company: '会社名',
    name: '氏名',
    name_kana: '氏名（カナ）',
    gender: '性別',
    phone_number: '携帯電話番号',
    icon: 'アイコン',
    password: 'パスワード',
    password_confirm: 'パスワード確認',
  },
  placeholder: {
    business_division_selection: '事業部選択',
    division_selection: '課選択',
    company_name_selection: '会社名選択',
    enter_new_password: '新しいパスワードを入力',
    confirm_new_password: '新しいパスワードを再度入力',
  },
  button: {
    saved: '保存しました',
    change: '変更',
    confirm_input: '入力を確認する',
    return_input: '入力に戻る',
    save: '保存する',
  },
}

export default lang
